import * as jobs from "context/actions/jobs";
import * as auth from "context/actions/auth";
import * as search from "context/actions/search";
import * as match from "context/actions/match";

const contextActions = { jobs, auth, search, match };

export { contextActions };
